<template>
  <v-snackbar v-bind="$attrs" v-on="$listeners" :value="value" :timeout="timeout" right top>
    {{ message }}
    <!-- <template v-slot:action="{ $attrs }">      
      <v-btn
        color="secondary"
        icon
        large
        v-bind="$attrs"
        @click="value=false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template> -->
  </v-snackbar>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    timeout: 6000, // ms
  }),

  methods: {
    //
  },
}
</script>
